import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

const DocumentoRelacionado = ({
    register,
    selectedValuesDDL,
    setSelectedValuesDDL,
    errors,
    clearError,
    selectedFactura
}) => {
    const registerField = (name = '') => register && typeof register === 'function' ? register(name) : {};

    // Populate vMetodoPagoDR from selectedFactura
    useEffect(() => {
        if (selectedFactura?.vMetodoPago) {
            setSelectedValuesDDL(prev => ({
                ...prev,
                vMetodoPagoDR: selectedFactura.vMetodoPago
            }));
        }
    }, [selectedFactura]);

    // Funci�n para abrir la factura en nueva pesta�a
    const handleOpenInvoice = () => {
        if (selectedFactura?.idFacturaEmitida) {
            const url = `/contabilidad/centro-xml/facturas-emitidas/visualizacion/${selectedFactura.idFacturaEmitida}`;
            window.open(url, '_blank');
        }
    };

    return (
        <>
            <h5 className="mb-3">Documento Relacionado</h5>
            <Row className="g-2">
                <Col md={12}>
                    <Form.Group>
                        <Form.Label>ID Documento</Form.Label>
                        <div className="d-flex align-items-center">
                            <Form.Control
                                size="sm"
                                type="text"
                                value={selectedFactura?.vUUIDFactura || ''}
                                readOnly
                                style={{ flex: 1, marginRight: '8px', cursor: 'pointer', backgroundColor: '#e9ecef' }}
                                onClick={handleOpenInvoice}
                                title="Haga clic para ver la factura"
                            />
                            {selectedFactura?.idFacturaEmitida && (
                                <FontAwesomeIcon
                                    icon={faExternalLinkAlt}
                                    className="text-primary"
                                    style={{ cursor: 'pointer' }}
                                    onClick={handleOpenInvoice}
                                    title="Abrir factura en nueva pesta�a"
                                />
                            )}
                        </div>
                        {errors.vIdDocumento && <div className="text-danger small">{errors.vIdDocumento}</div>}
                    </Form.Group>
                </Col>
            </Row>
            <Row className="g-2">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>M�todo de Pago DR</Form.Label>
                        <Form.Control
                            size="sm"
                            type="text"
                            value={selectedFactura?.vMetodoPago || 'PPD'}
                            readOnly
                        />
                        {errors.vMetodoPagoDR && <div className="text-danger small">{errors.vMetodoPagoDR}</div>}
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Objeto Impuesto DR</Form.Label>
                        <Form.Select
                            size="sm"
                            value={selectedValuesDDL.vObjetoImpDR}
                            onChange={(e) => {
                                setSelectedValuesDDL({ ...selectedValuesDDL, vObjetoImpDR: e.target.value });
                                clearError('vObjetoImpDR');
                            }}
                        >
                            <option value="">Seleccione...</option>
                            <option value="01">01 - No objeto de impuesto</option>
                            <option value="02">02 - S� objeto de impuesto</option>
                            <option value="03">03 - S� objeto del impuesto y no obligado al desglose</option>
                        </Form.Select>
                        {errors.vObjetoImpDR && <div className="text-danger small">{errors.vObjetoImpDR}</div>}
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <Form.Group>
                        <Form.Label>Parcialidad</Form.Label>
                        <Form.Control
                            size="sm"
                            type="number"
                            step="1"
                            {...registerField('iNumeroParcialidad')}
                        />
                        {errors.iNumeroParcialidad && <div className="text-danger small">{errors.iNumeroParcialidad}</div>}
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group>
                        <Form.Label>Serie DR</Form.Label>
                        <Form.Control
                            size="sm"
                            type="text"
                            value={selectedFactura?.vSerie || ''}
                            readOnly
                        />
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group>
                        <Form.Label>Folio DR</Form.Label>
                        <Form.Control
                            size="sm"
                            type="text"
                            value={selectedFactura?.vFolio || ''}
                            readOnly
                        />
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group>
                        <Form.Label>Moneda DR</Form.Label>
                        <Form.Control
                            size="sm"
                            type="text"
                            value={selectedFactura?.vMoneda || ''}
                            readOnly
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="g-2">
                <Col md={4}>
                    <Form.Group>
                        <Form.Label>Saldo Anterior</Form.Label>
                        <Form.Control
                            size="sm"
                            type="number"
                            step="0.01"
                            {...registerField('dSaldoAnterior')}
                        />
                        {errors.dSaldoAnterior && <div className="text-danger small">{errors.dSaldoAnterior}</div>}
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label>Importe del Pago</Form.Label>
                        <Form.Control
                            size="sm"
                            type="number"
                            step="0.01"
                            {...registerField('dImportePago')}
                        />
                        {errors.dImportePago && <div className="text-danger small">{errors.dImportePago}</div>}
                    </Form.Group>
                </Col>
                <Col md={4}>
                    <Form.Group>
                        <Form.Label>Saldo Insoluto</Form.Label>
                        <Form.Control
                            size="sm"
                            type="number"
                            step="0.01"
                            {...registerField('dSaldoInsoluto')}
                        />
                        {errors.dSaldoInsoluto && <div className="text-danger small">{errors.dSaldoInsoluto}</div>}
                    </Form.Group>
                </Col>
            </Row>
            <hr />
        </>
    );
};

DocumentoRelacionado.propTypes = {
    register: PropTypes.func.isRequired,
    selectedValuesDDL: PropTypes.object.isRequired,
    setSelectedValuesDDL: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    clearError: PropTypes.func.isRequired,
    selectedFactura: PropTypes.object
};

export default DocumentoRelacionado;
